import { styled } from "@mui/material/styles";
import { grey } from "@mui/material/colors";

export const TransparentBackdrop = styled("div")({
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "transparent",
  pointerEvents: "none", // Ensure the backdrop does not intercept any events
});

export const CustomModalRoot = styled("div")(
  ({
    theme,
    top,
    left,
    width,
    height,
    shadow,
    display,
    overflow,
    paddingbottom,
    maxheight,
  }) => ({
    position: "absolute",
    display: display || "block",
    flexDirection: "column",
    justifyContent: "space-between",
    border: "none",
    borderRadius: 12,
    overflow: overflow || "hidden",
    backgroundColor: "white",
    paddingX: 24,
    paddingBottom: paddingbottom || 24,
    pointerEvents: "auto",
    maxHeight: `${maxheight}% !important` || "none",
    [theme.breakpoints.down("md")]: {
      width: "100% !important",
      height: "90% !important",
      borderRadius: "0 0",
      bottom: 0,
      left: 0,
    },
    [theme.breakpoints.up("md")]: {
      width: `${width}% !important`,
      height: `${height}% !important`,
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${left}%, -${top}%)`,
    },
    boxShadow:
      shadow !== undefined
        ? theme.shadows[shadow] || theme.shadows[24]
        : theme.shadows[24],
  })
);

export const CustomCentralizedModalRoot = styled("div")(
  ({ theme, top, left, overflow, width, height, shadow, backgroundColor }) => ({
    position: "absolute",
    border: "none",
    borderRadius: 12,
    overflow: overflow || "hidden",
    [theme.breakpoints.down("md")]: {
      width: "100% !important",
      height: "90% !important",
      borderRadius: "0 0",
      bottom: 0,
      left: 0,
    },
    [theme.breakpoints.up("md")]: {
      width: `${width}% !important`,
      height: `${height}% !important`,
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${left}%, -${top}%)`,
    },
    backgroundColor: backgroundColor || grey["50"],
    pointerEvents: "auto",
    boxShadow: shadow || theme.shadows[24],
    // Centering content vertically and horizontally
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  })
);

export const StyledModalRoot = styled("div")(
  ({ theme, top, left, width, overflow, maxHeight }) => ({
    padding: 16,
    top: top || "50%",
    left: left || "50%",
    width: width || 400,
    position: "absolute",
    overflow: overflow || "auto",
    maxHeight: maxHeight || "90vh", // Default to 90% of the viewport height
    height: "auto", // Let the height adapt to the content
    boxShadow: 24,
    borderRadius: 8,
    transform: "translate(-50%, -50%)",
    backgroundColor: grey["50"],
    display: "flex",
    flexDirection: "column", // Ensure it behaves like a column
    [theme.breakpoints.down("md")]: {
      width: "100% !important",
      maxHeight: "100% !important", // Ensure it uses full height on small screens
      borderRadius: "0 0",
      bottom: 0,
    },
  })
);
